import {TranslationFunction} from "../i18n/i18n";
import {CatalogFormatter} from "./catalog/CatalogFormatter";

export class CurrencyFormatter {

    static formatCurrencyFromCode(currencyCode: string | undefined | null, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(currencyCode, 'currency', t);
    }
}